import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingpageComponent } from './landingpage/landingpage.component';
import { homelayoutcomponent } from './layout/homelayout.component';
import { ProductSubcategoryComponent } from './productsubcategory/productsubcategory.component';
import { PrintgroupsComponent } from './printgroups/printgroups.component';
import { SpecpageComponent } from './specpage/specpage.component';
import { NomenclatureComponent } from './nomenclature/nomenclature.component';
import { CasepackComponent } from './casepack/casepack.component';
import { CategoryComponent } from './category/category.component';
import { CompatibleitemComponent } from './compatibleitem/compatibleitem.component';
import { MaterialComponent } from './material/material.component';
import { PrintgroupComponent } from './printgroup/printgroup.component';
import { ProductComponent } from './product/product.component';
import { SubcategoryComponent } from './subcategory/subcategory.component';
//import { AuthGuard } from './security/auth.guard'
import { loginlayoutcomponent } from './layout/loginlayout.component';
import { LoginComponent } from './menu/login.component';
import { LogoutComponent } from './menu/logout.component';
import { AccessdeniedComponent } from './accessdenied/accessdenied.component';
import { SearchresultsComponent } from './searchresults/searchresults.component';
import { ProductpdfComponent } from './productpdf/productpdf.component';
import { DataInsertComponent } from './data-insert/data-insert.component';
import { MsalGuard } from '@azure/msal-angular';
export const appRoutes: Routes = [
  {
      path: '',
      component: homelayoutcomponent,
      children: [
      { path: '', redirectTo: 'home', pathMatch: 'full'},
      { path: 'home', component: LandingpageComponent},
      { path: 'subcategory/:id' , component: ProductSubcategoryComponent},
      { path: 'printgroups/:id' , component: PrintgroupsComponent},
      { path: 'nomenclature/:id/:printGroup/:isEcotainer/:isCompliancePackaging' , component: NomenclatureComponent},
      { path: 'search/:searchterm' , component: SearchresultsComponent},
      { path: 'specpage/:productId' , component: SpecpageComponent},
      { path: 'dataInsert', component: DataInsertComponent},
      { path: 'admin/casepack', component: CasepackComponent, canActivate: [MsalGuard]},
      { path: 'admin/compatibleitem', component: CompatibleitemComponent, canActivate: [MsalGuard]},
      { path: 'admin/material', component: MaterialComponent, canActivate: [MsalGuard]},
      { path: 'admin/product', component: ProductComponent, canActivate: [MsalGuard]},
      { path: 'admin/category', component: CategoryComponent, canActivate: [MsalGuard]},
      { path: 'admin/printgroup', component: PrintgroupComponent, canActivate: [MsalGuard]},
      { path: 'admin/subcategory', component: SubcategoryComponent, canActivate: [MsalGuard]}      ]
  },
  {
    path: '',
    component: loginlayoutcomponent,
    children:[
        { path: 'login', component: LoginComponent},
        { path: 'logout', component: LogoutComponent},
        { path: 'accessdenied', component: AccessdeniedComponent}

    ]
},
{
  path: '',
  children:[
      { path: 'productpdf/:productId/:casePack' , component: ProductpdfComponent}

  ]
},
  { path: '**', redirectTo: '' }
  ];
 
@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
